import { Table } from 'antd';

const SimpleTable = ({ columns = [], data = [], pagination = false, border = true }) => {
  return (
    <Table columns={columns} dataSource={data} pagination={pagination} className="simple-table" bordered={border} />
  );
};

export default SimpleTable;
